{
  "longPressMessage": "Long press to open preview"
}
